import { Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import { useCallback, useEffect } from "react";
import { useForm } from "react-hook-form";
import { ReportsDocumentosForm } from "../../../schemas/Funcionarios_lista/reports_documentos";
import { CentroCustoDropDown } from "../../../../../../common/domain/models/centro_custo_dropdown";
import { FuncionarioNomeDropDown } from "../../../../domain/models/funcionario_nome_dropdown";
import { DefaultFormMultiAutocomplete } from "../../../../../../common/components/default_form_multi_autocomplete";
import { DefaultFormAutocomplete } from "../../../../../../common/components/default_form_autocomplete";
import { ModalLoading } from "../../../../../../common/components/modal_loading";
import { FormRangeDatePickerInput } from "../../../../../../common/components/masked_inputs/react_forms/form_date_range_picker_input";

import FormContainer from "../../../../../../common/components/form_container";
import PrimaryButton from "../../../../../../common/components/primary_button";

/**
 * ReportsDocumentos
 */

type Props = {
  open: boolean,
  saving: boolean,
  loading: boolean,
  funcionarioNomesLista: FuncionarioNomeDropDown[],
  centroCustoLista: CentroCustoDropDown[],
  onClose: () => void,
  onSubmit: (form: ReportsDocumentosForm) => void,
};

export const ReportsDocumentos = ({
  open,
  saving,
  loading,
  funcionarioNomesLista,
  centroCustoLista,
  onClose,
  onSubmit,
}: Props) => {
  const hookForm = useForm<ReportsDocumentosForm>({});

  useEffect(() => {
    if (open) hookForm.reset();
  }, [hookForm, open]);

  const handleClose = useCallback(() => {
    onClose();
  }, [onClose]);

  return (
    <Dialog
      open={open}
      slotProps={{
        paper: {
          component: 'form',
          onSubmit: hookForm.handleSubmit(onSubmit),
        }
      }}
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: "80rem",
          },
        },
      }}>
      <DialogTitle>
        Relatório Documentos Funcionários
      </DialogTitle>

      <DialogContent>
        <ModalLoading loading={loading || saving}>
          <FormContainer title={"Informações"} arrangement="fullRow">
            <>
              <DefaultFormMultiAutocomplete
                name='funcionario'
                label='Funcionario'
                options={funcionarioNomesLista}
                getOptionKey={x => x.idFuncionario}
                getOptionLabel={(x) => x.nome}
                reactHookForm={hookForm} />

              <DefaultFormAutocomplete
                name='statusDocumento'
                label='Status documento'
                options={[{ id: 0, nome: 'Em dia' }, { id: 1, nome: 'Vencidos' }, { id: 2, nome: 'Todos' }]}
                getOptionKey={(x) => x.id}
                getOptionLabel={(x) => x.nome}
                reactHookForm={hookForm} />

              <DefaultFormMultiAutocomplete
                name='centroCusto'
                label='Centro de Custo'
                options={centroCustoLista}
                getOptionKey={(x) => x.id}
                getOptionLabel={(x) => x.title}
                reactHookForm={hookForm} />

              <DefaultFormAutocomplete
                name='situacao'
                label='Situação do documento'
                options={[{ id: 0, nome: 'Atual' }, { id: 1, nome: 'Obsoleto' }, { id: 2, nome: 'Todos' }]}
                getOptionKey={(x) => x.id}
                getOptionLabel={(x) => x.nome}
                reactHookForm={hookForm} />

              <DefaultFormAutocomplete
                name='statusFuncionario'
                label='Status Funcionário'
                options={[{ id: 0, nome: 'Ativos' }, { id: 1, nome: 'Demitidos' }, { id: 2, nome: 'Todos' }]}
                getOptionKey={(x) => x.id}
                getOptionLabel={(x) => x.nome}
                reactHookForm={hookForm} />

              <FormRangeDatePickerInput
                label='Vencimento'
                name='dataVencimento'
                reactHookForm={hookForm}
              />

              <FormRangeDatePickerInput
                label='Data de emissão'
                name='dataEmissao'
                reactHookForm={hookForm}
              />

            </>
          </FormContainer>
        </ModalLoading>
      </DialogContent>

      <DialogActions>
        <div className="w-full h-full items-center justify-end flex p-4 gap-4">
          <div className="flex flex-row gap-2">
            <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
              <h1
                className="text-sm text-black dark:text-white"
                onClick={handleClose}>
                Cancelar
              </h1>
            </div>

            <div className="w-[120px]">
              <PrimaryButton
                type="submit"
                buttonColor="primary-green">
                Gerar
              </PrimaryButton>
            </div>
          </div>
        </div>
      </DialogActions>
    </Dialog>
  );
}